const getters = {
  pdfs: (state) => state.common.pdfs,
  vid: (state) => state.common.vid,
  page: (state) => state.common.page,
};
export default getters;
